import { render, staticRenderFns } from "./CreateLocationCatalogue.vue?vue&type=template&id=1513a7b4&scoped=true&"
import script from "./CreateLocationCatalogue.vue?vue&type=script&lang=ts&"
export * from "./CreateLocationCatalogue.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLocationCatalogue.vue?vue&type=style&index=0&id=1513a7b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513a7b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1513a7b4')) {
      api.createRecord('1513a7b4', component.options)
    } else {
      api.reload('1513a7b4', component.options)
    }
    module.hot.accept("./CreateLocationCatalogue.vue?vue&type=template&id=1513a7b4&scoped=true&", function () {
      api.rerender('1513a7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/CreateLocationCatalogue.vue"
export default component.exports